import { APIRequest, APIRequestDtoImpl } from '../../apiRequest';
import { GenerateOTPDto } from '../../../dto/otp/generateotp/generateotpdto';

export interface GenerateOTPRequest extends APIRequest
{
    getGenerateOTPRequest(): GenerateOTPDto;
}

export class GenerateOTPRequestImpl extends APIRequestDtoImpl implements GenerateOTPRequest
{
    constructor(private generateOTPData: GenerateOTPDto)
    {
        super();
    }

    getGenerateOTPRequest(): GenerateOTPDto
    {
        return this.generateOTPData;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/otp/generateotp/generateotprequest.tsx